import { fetchApi, ADMIN_API } from '@/api/client'
import type { PipelineMonitorResponse, FileIngestionStatus } from '../types'

const BASE = `${ADMIN_API}/pipeline`

export async function getPipelineFiles(params: {
  accId: number
  limit?: number
  status?: string
}): Promise<PipelineMonitorResponse> {
  const query = new URLSearchParams()
  query.set('accId', String(params.accId))
  query.set('limit', String(params.limit ?? 20))
  if (params.status && params.status !== 'ALL') query.set('status', params.status)
  return fetchApi<PipelineMonitorResponse>(`${BASE}/files?${query}`)
}

export async function getPipelineFileStatus(fileId: string): Promise<FileIngestionStatus> {
  return fetchApi<FileIngestionStatus>(`${BASE}/files/${fileId}`)
}
